<template>
  <section class="steps-main">
    <div class="steps-main__bg"></div>
    <div class="steps-main__content">
      <div class="step-head">
        <div class="container">
          <div class="head-row">
            <div class="head-row__position">
              <i18n path="forms.formHeader" tag="h2">
                <span>{{ this.$i18n.t("user.step") }}</span>
              </i18n>
            </div>
            <h1>{{ this.$i18n.t("user.stepDescription") }}</h1>
            <img src="@/assets/head-paso1.svg" class="head-row__img" />
          </div>
        </div>
      </div>
      <div class="container">
        <div class="box-form box-form--step2">
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols="12" xs="12" sm="12" md="12" lg="10" xl="10">
              <v-form ref="form" v-model="valid" @submit.prevent="saveUserInfo">
                <div class="row-form">
                  <div class="col-form">
                    <div class="col-form__item">
                      <label>{{ this.$i18n.t("user.names") }}</label>
                      <v-text-field id="user-names" v-model="names" :rules="nameRules" required
                        autocomplete="off"></v-text-field>
                    </div>
                  </div>
                  <div class="col-form">
                    <div class="col-form__item">
                      <label>{{ this.$i18n.t("user.lastNames") }}</label>
                      <v-text-field id="user-last-names" v-model="family_names" :rules="nameRules" required
                        autocomplete="off"></v-text-field>
                    </div>
                  </div>
                  <div class="col-form">
                    <div class="col-form__item">
                      <label>{{ this.$i18n.t("user.rut") }}</label>
                      <v-text-field id="user-rut" v-model="rut" :rules="rutRules" :hint="this.$i18n.t('hints.rut')"
                        persistent-hint required autocomplete="off"></v-text-field>
                    </div>
                  </div>
                  <div class="col-form">
                    <div class="col-form__item col-form__item--select">
                      <label>{{ this.$i18n.t("user.gender") }}</label>
                      <v-autocomplete v-model="gender" :rules="genderRules" :items="genders" item-text="sex"
                        item-value="code" required id="user-gender"></v-autocomplete>
                    </div>
                  </div>
                  <div class="col-form">
                    <div class="col-form__item col-form__item--select">
                      <label>{{ this.$i18n.t("user.birthday") }}</label>
                      <v-row>
                        <v-col>
                          <label>{{ this.$i18n.t("user.day") }}</label>
                          <v-text-field id="birthday-input-1" v-model="day" required autocomplete="off" maxlength="2"
                            hide-details oninput="this.value=this.value.slice(0,this.maxLength)" :rules="shortDateRules"
                            type="number" />
                        </v-col>
                        <v-col>
                          <label>{{ this.$i18n.t("user.month") }}</label>
                          <v-text-field id="birthday-input-2" v-model="month" required autocomplete="off" maxlength="2"
                            hide-details oninput="this.value=this.value.slice(0,this.maxLength)" :rules="shortDateRules"
                            type="number" />
                        </v-col>
                        <v-col>
                          <label>{{ this.$i18n.t("user.year") }}</label>
                          <v-text-field id="birthday-input-3" v-model="year" required autocomplete="off" maxlength="4"
                            hide-details oninput="this.value=this.value.slice(0,this.maxLength)" :rules="longDateRules"
                            type="number" />
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                  <div class="col-form">
                    <div class="col-form__item col-form__item--select">
                      <label>{{ this.$i18n.t("user.birthCountry") }}</label>
                      <label><br /></label>
                      <v-autocomplete v-model="birth_country" :rules="countryRules" :items="countries" item-text="country"
                        item-value="code" required id="user-birth-country"></v-autocomplete>
                    </div>
                  </div>
                  <div class="col-form">
                    <div class="col-form__item col-form__item--select">
                      <label>{{ this.$i18n.t("user.nationality") }}</label>
                      <v-autocomplete v-model="nationality" :rules="countryRules" :items="countries" item-text="country"
                        item-value="code" required id="user-nationality"></v-autocomplete>
                    </div>
                  </div>
                  <div class="col-form">
                    <div class="col-form__item col-form__item--select">
                      <label>{{ this.$i18n.t("user.maritalStatus") }}</label>
                      <v-autocomplete v-model="marital_status" :items="maritalStatus" :rules="maritalRules"
                        item-text="status" item-value="code" required id="user-marital-status"></v-autocomplete>
                    </div>
                  </div>
                  <div class="col-form" v-if="marital_status === 2">
                    <div class="col-form__item">
                      <label>{{ this.$i18n.t("user.spouseNames") }}</label>
                      <v-text-field id="user-spouse-names" v-model="spouse_name" :rules="nameRules" required
                        autocomplete="off"></v-text-field>
                    </div>
                  </div>
                  <div class="col-form" v-if="marital_status === 2">
                    <div class="col-form__item">
                      <label>{{ this.$i18n.t("user.spouseLastNames") }}</label>
                      <v-text-field id="user-spouse-family-names" v-model="spouse_family_name" :rules="nameRules" required
                        autocomplete="off"></v-text-field>
                    </div>
                  </div>
                  <div class="col-form" v-if="marital_status === 2">
                    <div class="col-form__item">
                      <label>{{ this.$i18n.t("user.spouseRut") }}</label>
                      <v-text-field id="user-spouse-rut" v-model="spouse_rut" :rules="rutRules"
                        :hint="this.$i18n.t('hints.rut')" persistent-hint required autocomplete="off"></v-text-field>
                    </div>
                  </div>
                </div>
                <div class="box-btns">
                  <v-btn class="btn-finish" color="primary" :loading="loading" :disabled="!valid || loading || !validDate"
                    type="submit" id="bank-submit-button">
                    {{ this.$i18n.t("user.buttonContinue") }}</v-btn>
                </div>
              </v-form>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </div>
      </div>
      <v-dialog v-model="savingDialog" persistent width="300">
        <v-card color="primary" dark>
          <div class="ma-2">
            <v-card-text>
              <p>{{ this.$i18n.t("user.savingDialog") }}</p>
              <v-progress-linear indeterminate color="white"></v-progress-linear>
            </v-card-text>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="errorDialog" width="300">
        <v-card>
          <v-card-text>
            <div class="box-photo text-alert">
              <v-icon color="primary">mdi-alert-circle-outline</v-icon>
              <p>{{ errorMessage }}</p>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="errorDialog = false">{{ this.$i18n.t("errors.button") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="existsDialog" width="300" persistent>
        <v-card>
          <v-card-text>
            <div class="box-photo text-alert">
              <v-icon color="primary">mdi-alert-circle-outline</v-icon>
              <i18n path="user.exists.first" tag="p">
                <a target="_blank" href="https://clientes.ameris.cl">{{ $i18n.t("user.exists.link") }}</a>
              </i18n>
              <p>{{ $i18n.t("user.exists.second") }}</p>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="existsDialog = false">{{ this.$i18n.t("errors.button") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </section>
</template>

<script>
/* eslint-disable arrow-parens, operator-linebreak, implicit-arrow-linebreak */
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { formSelects } from "@/mixins/formSelects";

dayjs.extend(customParseFormat);

const { validate } = require("rut.js");

export default {
  name: "PersonalForm",
  mixins: [formSelects],
  data() {
    return {
      errorDialog: false,
      errorMessage: this.$i18n.t("errors.default"),
      savingDialog: false,
      existsDialog: false,
      valid: false,
      menuS: false,
      menuBirthday: null,
      loading: false,
      isEditing: false,
      names: null,
      family_names: null,
      gender: null,
      // birthday: null,
      day: null,
      month: null,
      year: null,
      rut: null,
      nationality: "CHL",
      birth_country: "CHL",
      marital_status: null,
      spouse_name: null,
      spouse_family_name: null,
      spouse_rut: null,
      rutRules: [v => !!v || this.$i18n.t("forms.formMustComplete"), v => validate(v) || this.$i18n.t("forms.formRut")],
      nameRules: [v => !!v || this.$i18n.t("forms.formMustComplete")],
      genderRules: [v => !!v || this.$i18n.t("forms.formMustComplete"), v => this.genders.some(el => el.code === v) || this.$i18n.t("forms.formGeneric")],
      countryRules: [v => !!v || this.$i18n.t("forms.formMustComplete"), v => this.countries.some(el => el.code === v) || this.$i18n.t("forms.formCountry")],
      shortDateRules: [v => !!v || this.$i18n.t("forms.formMustComplete"), v => /[0-9]{2}/.test(v)],
      longDateRules: [v => !!v || this.$i18n.t("forms.formMustComplete"), v => /[0-9]{4}/.test(v)],
      // birthdayRules: [v => !!v || this.$i18n.t("forms.formMustComplete"), v => /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/.test(v)],
      maritalRules: [v => !!v || this.$i18n.t("forms.formMustComplete"), v => this.maritalStatus.some(el => el.code === v) || this.$i18n.t("forms.formGeneric")],
    };
  },
  computed: {
    validDate() {
      if (this.year && this.month && this.day) {
        const enteredDate = `${this.year}/${this.month.padStart(2, "0")}/${this.day.padStart(2, "0")}`;
        return dayjs(enteredDate, "YYYY/MM/DD", true).isValid();
      }
      return false;
    },
  },
  methods: {
    maxDate() {
      const current = new Date();
      current.setFullYear(current.getFullYear() - 18);
      return current.toISOString().substr(0, 10);
    },
    async verifyRut(rut) {
      try {
        const response = await this.axios.post(
          `${process.env.VUE_APP_BACKEND}personal/rut`,
          { rut, email: this.$store.state.email },
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
            },
          },
        );
        if (response.data.code !== 200) {
          return { error: true };
        }
        if (response.data.exists) {
          return { exists: true };
        }
        return { exists: false };
      } catch {
        return { error: true };
      }
    },
    async saveUserInfo() {
      this.loading = true;
      this.savingDialog = true;
      const verified = await this.verifyRut(this.rut);
      if (verified.error) {
        this.savingDialog = false;
        this.loading = false;
        this.errorDialog = true;
        return;
      }
      if (verified.exists) {
        this.savingDialog = false;
        this.loading = false;
        this.existsDialog = true;
        return;
      }
      this.$store.commit("updatePersonalData", {
        name: this.names,
        family_name: this.family_names,
        gender: this.gender,
        birthday: `${this.year}-${this.month.padStart(2, "0")}-${this.day.padStart(2, "0")}`,
        rut: this.rut,
        birth_country: this.birth_country,
        nationality: this.nationality,
        marital_status: this.marital_status,
        spouse_name: this.marital_status === 2 ? this.spouse_name : null,
        spouse_family_name: this.marital_status === 2 ? this.spouse_family_name : null,
        spouse_rut: this.spouse_rut === 2 ? this.spouse_rut : null,
      });
      this.$store.commit("updateFormStep", { step: 2 });
      this.$router.push("addressform");
    },
    save(birthday) {
      this.$refs.menuS.save(birthday);
    },
  },
  mounted() { },
};
</script>

<style scoped></style>
